<ngx-loading
  [show]="loading"
  [config]="{
    animationType: ngxLoadingAnimationTypes.chasingDots,
    primaryColour: primaryColour,
    secondaryColour: secondaryColour,
    backdropBackgroundColour: showBackground ? 'rgb(43 27 68 / 25%)' : 'transparent',
    backdropBorderRadius: '3px'
  }"
  [template]="loadingTemplate"
></ngx-loading>

<div class="text" *ngIf="loading && text?.length">{{text}}</div>
